import Moment from "moment";
import Numeral from "numeral";
import ReactGA from "react-ga4";
import { trackActivity } from "../crud/avm.crud";
import {
  COMMA_SEPARATE_VALUE,
  DATE_FORMAT_FRONT,
  DEFAULT_TEXT_LIMIT,
  DEVICE_WIDTH,
  NUMBER_ORDINAL_SUFFIX,
  TRACK_ACTIVITY,
} from "./Constants";
import { PROPERTY_TYPES } from "./Mock";

const { REACT_APP_GA_TRACK, REACT_APP_GA_TOKEN,REACT_APP_REPORT_API_URL } = process.env;

export function getQueryString(values) {
  const commaSepValue = Object.keys(values)
    .map((key) => `${key}=${values[key]}`)
    .join("&");
  return commaSepValue;
}

export function getBedAndBath(value, room = "bedrooms") {
  const roomValue =
    value <= 12 && value >= 1
      ? Number(value)
      : room === "bedrooms"
      ? "Studio"
      : 1;
  return roomValue;
}

export function getPropertyTypeGroup(value) {
  const propertyTypeId = value;
  const propertyTypes = getPropertyTypes(propertyTypeId);
  let getPropertyTypeGroup = 1;
  let tempKey;
  if (propertyTypeId) {
    tempKey = Object.keys(propertyTypes).find(
      (key) => propertyTypes[key].id === propertyTypeId
    );
    if (tempKey)
      getPropertyTypeGroup = propertyTypes[tempKey].property_type_group;
  }
  return getPropertyTypeGroup;
}

// replace all existence.
export const customReplaceAll = (text, find, replace) => {
  let replaced = "";
  if (text && find && replace) {
    replaced = text.replace(new RegExp(find, "g"), replace);
  }
  return replaced;
};

export const dateFormat = (date) => {
  return Moment(date).format(DATE_FORMAT_FRONT);
};
export const commaSeparateFormat = (value) => {
  return value ? Numeral(value).format(COMMA_SEPARATE_VALUE) : "";
};
export const getYearlyServiceCharges = (serviceCharges, unitSize) => {
  let tempServiceCharge;
  if (serviceCharges) {
    tempServiceCharge = serviceCharges * unitSize;
    tempServiceCharge = Math.round(tempServiceCharge / 100) * 100;
    tempServiceCharge = Numeral(tempServiceCharge).format(COMMA_SEPARATE_VALUE);
  }
  return tempServiceCharge;
};

export const getPropertyTypeName = (value) => {
  let result = "";
  const propertyTypes = getPropertyTypes(value);
  if (value) {
    result = propertyTypes.find((entry) => entry.id === parseInt(value));
    result = result.name;
  }

  return result;
};

export const getRoundOfValue = (value) => {
  let rounded = "";
  if (value) {
    rounded = Numeral(value).format();
  }
  return rounded;
};
export const capitalize = (string) =>
  string && string.charAt(0).toUpperCase() + string.slice(1);

export const scrollToView = (ref = "body") => {
  if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }
};

export const getActualValue = (value) => {
  let rounded = "";
  if (value) {
    rounded = Numeral(value).value();
  }
  return rounded;
};

export const getFilterUpgrades = (upgrades, propertyTypeId) => {
  let tempUpgrades = [];
  if (propertyTypeId) {
    const propertyTypeGroup = getPropertyTypeGroup(propertyTypeId);
    tempUpgrades = upgrades.filter((obj) =>
      obj.propertyTypeGroup.includes(propertyTypeGroup)
    );
  }
  return tempUpgrades;
};

export const getRandomNumber = () => {
  let text = "";
  text = "_" + Math.random().toString(36).substr(2, 12);
  return text;
};

export const getOrdinalSuffix = (value) => {
  let tempFloor = value;
  if (value > 0) {
    tempFloor = Numeral(value).format(NUMBER_ORDINAL_SUFFIX);
  }
  return tempFloor;
};

export const _trackActivity = async (params) => {
  try {
    if (TRACK_ACTIVITY) {
      const location = window?.location || ""
      const referrer = (window.location !== window.parent.location)
        ? document.referrer
        : document.location.href;
      let searchParams = new URLSearchParams(location?.search);
      const utmMedium = searchParams?.get("utm_medium") || ""
      const utmSource = searchParams?.get("utm_source") || ""
      const utmCampaign = searchParams?.get("utm_campaign") || ""
      const postParams = {
        event: params?.event || "",
        action: params?.action || "",
        url: location?.href || "",
        context: params?.context || "",
        session: params?.currentSession || "",
        userId: params?.userId || "",
        userConsumerId: params?.userConsumerId || "",
        status: params?.status || "",
        entity: "consumer-avm",
        utmMedium,
        utmSource,
        utmCampaign,
        referrer
      };
      const result = await trackActivity(postParams);
      const { status } = result.data;
      if (status === 1) {
        console.log("tracker!!");
      } else {
        console.log("activity tracker went wrong!!");
      }
    }
  } catch (e) {
    console.log(e);
  }
};
export const IsNotValidEmail = (email) => {
  return !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
};

export const IsNotValidMobileNumber = (mobileNumber) => {
  return !/^\+?[\d ]+$/.test(mobileNumber.trim());
};

export const toggleText = (
  fullText,
  limitText = DEFAULT_TEXT_LIMIT,
  showHideText
) => {
  let appendText = "...";
  let tempText = fullText;
  if (tempText.length > limitText && showHideText) {
    tempText = fullText.substr(0, limitText) + appendText;
  }


  return tempText;
};

// GA Tracking https://github.com/react-ga/react-ga
export const initGa = () => {
  if (REACT_APP_GA_TRACK === "ON") {
    ReactGA.initialize(REACT_APP_GA_TOKEN);
  } else {
    console.log("Ga is disabled");
  }
};

export const sendEventsInGoogleAnalytics = (
  category = null,
  action = null,
  label = null,
  value = 0
) => {
  if (REACT_APP_GA_TRACK === "ON") {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};
export const setUserForGa = (data) => {
  if (REACT_APP_GA_TRACK === "ON") {
    ReactGA.set(data);
  }
};

// path	String. e.g. '/get-involved/other-ways-to-help'
// trackerNames	Array. Optional. A list of extra trackers to run the command on
// title	String. Optional. e.g. 'Other Ways to Help'

export const sendPageView = (path) => {
  if (REACT_APP_GA_TRACK === "ON") {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};
export const getPropertyTypes = (propertyTypeId) => {
  let propertyTypes = [...PROPERTY_TYPES];
  if (propertyTypeId && parseInt(propertyTypeId) === 3) {
    //hotel apartment
    const tempPropertyType = {
      id: 3,
      name: "Apartment",
      category: "residential",
      status: 1,
      property_type_group: 1,
    };
    propertyTypes[0] = tempPropertyType;
  }
  return propertyTypes;
};

export const downloadReport =(reportId, action="view")=>{
  const url = `${REACT_APP_REPORT_API_URL}?reportId=${reportId}&action=${action}`
  window.open(url, "_blank")
}

export const isMobileWidth = { width: DEVICE_WIDTH - 120 };

export const getBedRooms = (length = 10) => {
  let bedRooms = [
    { id: "Studio", name: "Studio" },
    { id: 1, name: "1" },
    { id: 2, name: "2" },
    { id: 3, name: "3" },
    { id: 4, name: "4" },
    { id: 5, name: "5" },
    { id: 6, name: "6" },
    { id: 7, name: "7" },
    { id: 8, name: "8" },
    { id: 9, name: "9" },
    { id: 10, name: "10" },
    { id: 11, name: "11" },
    { id: 12, name: "12" },
    { id: 13, name: "13" },
    { id: 14, name: "14" },
    { id: 15, name: "15" },
    { id: 16, name: "16" },
    { id: 17, name: "17" },
    { id: 18, name: "18" },
    { id: 19, name: "19" },
    { id: 20, name: "20" },
  ];
  bedRooms = bedRooms.slice(0, length + 1);
  return bedRooms;
};
export const getBathRooms = (length = 10) => {
  let bathRooms = [
    { id: 1, name: "1" },
    { id: 2, name: "2" },
    { id: 3, name: "3" },
    { id: 4, name: "4" },
    { id: 5, name: "5" },
    { id: 6, name: "6" },
    { id: 7, name: "7" },
    { id: 8, name: "8" },
    { id: 9, name: "9" },
    { id: 10, name: "10" },
    { id: 11, name: "11" },
    { id: 12, name: "12" },
    { id: 13, name: "13" },
    { id: 14, name: "14" },
    { id: 15, name: "15" },
    { id: 16, name: "16" },
    { id: 17, name: "17" },
    { id: 18, name: "18" },
    { id: 19, name: "19" },
    { id: 20, name: "20" },
  ];
  bathRooms = bathRooms.slice(0, length + 1);
  return bathRooms;
};
export const formatFloatValue = (value) => {
  return value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};